import { isMobile } from '../utils/commonUtils'
import {
  SETTINGS_EDIT_MAMORIO,
  SETTINGS_EVENT_TRIGGERS,
  SETTINGS_GROUP_MANAGEMENT,
  SETTINGS_MAMORIO_SPOT,
  SETTINGS_QR_TAGS,
  SETTINGS_RFID,
  SETTINGS_BIZ_ACCESS_LOGS,
} from './Paths'
import { teamHasQrTags } from '../helpers/qrTagFeature'
import teamHasDevices from '../helpers/deviceFeature'

export interface SettingTabContent {
  label: string
  url: string
}

type SettingTabsOptions = {
  groups?: IGroup[] | null
  deviceEnabled?: boolean | null
  qrTagEnabled?: boolean | null
  rfidTagEnabled?: boolean | null
  eventNotificationSettingsEnable?: boolean | null
}

const SettingTabsInfo = ({
  groups = null,
  deviceEnabled = null,
  qrTagEnabled = null,
  rfidTagEnabled = null,
  eventNotificationSettingsEnable = null,
}: SettingTabsOptions = {}): SettingTabContent[] => {
  const shouldShowEventTriggerTab = Boolean(eventNotificationSettingsEnable)
  const shouldShowDeviceTab = teamHasDevices({ device_enabled: deviceEnabled })
  const shouldShowQrTagTab = teamHasQrTags({ qr_tag_enabled: qrTagEnabled })
  const shouldShowRfidTagTab = rfidTagEnabled === true
  const shouldShowBizAccessLogTab = Boolean(groups?.some((group) => group.biz_access_log_enabled))

  if (isMobile()) {
    const mobileTabs: SettingTabContent[] = [
      {
        label: 'MAMORIO',
        url: SETTINGS_EDIT_MAMORIO,
      },
      {
        label: 'グループ',
        url: SETTINGS_GROUP_MANAGEMENT,
      },
    ]

    if (shouldShowDeviceTab) {
      mobileTabs.push({
        label: 'Spot',
        url: SETTINGS_MAMORIO_SPOT,
      })
    }

    if (shouldShowQrTagTab) {
      mobileTabs.push({
        label: 'QRタグ',
        url: SETTINGS_QR_TAGS,
      })
    }

    if (shouldShowRfidTagTab) {
      mobileTabs.push({
        label: 'RFID',
        url: SETTINGS_RFID,
      })
    }

    if (shouldShowEventTriggerTab) {
      mobileTabs.push({
        label: 'イベント通知',
        url: SETTINGS_EVENT_TRIGGERS,
      })
    }

    if (shouldShowBizAccessLogTab) {
      mobileTabs.push({
        label: 'Bizアクセスログ',
        url: SETTINGS_BIZ_ACCESS_LOGS,
      })
    }

    return mobileTabs
  }

  const desktopTabs: SettingTabContent[] = [
    {
      label: 'MAMORIOの設定',
      url: SETTINGS_EDIT_MAMORIO,
    },
  ]

  if (shouldShowQrTagTab) {
    desktopTabs.push({
      label: 'QRタグの設定',
      url: SETTINGS_QR_TAGS,
    })
  }

  if (shouldShowRfidTagTab) {
    desktopTabs.push({
      label: 'RFIDの設定',
      url: SETTINGS_RFID,
    })
  }

  desktopTabs.push({
    label: 'グループの管理',
    url: SETTINGS_GROUP_MANAGEMENT,
  })

  if (shouldShowDeviceTab) {
    desktopTabs.push({
      label: 'MAMORIO Spotの管理',
      url: SETTINGS_MAMORIO_SPOT,
    })
  }

  if (shouldShowEventTriggerTab) {
    desktopTabs.push({
      label: 'イベント通知の管理',
      url: SETTINGS_EVENT_TRIGGERS,
    })
  }

  if (shouldShowBizAccessLogTab) {
    desktopTabs.push({
      label: 'Bizアクセスログ',
      url: SETTINGS_BIZ_ACCESS_LOGS,
    })
  }

  return desktopTabs
}

export default SettingTabsInfo
